export enum CalculateType
{
    Average = 1,
    Top = 2
}